import { FETCH_CONCERT_VIEW, UNLOAD_CURRENT_ARTIST } from '../actionTypes';
import { loadReducer } from './helpers';

export function concertView(state = null, action) {
  switch (action.type) {
    case FETCH_CONCERT_VIEW:
      return loadReducer(state, action);
    case UNLOAD_CURRENT_ARTIST:
      return null;
    default:
      return state;
  }
}
